(function () {
    "use strict";

    // @ngInject
    function BrandAvatarComponentCtor($scope, $injector, UsersManager, AccountsService, Enums) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'BrandAvatarComponent';

        this.user = UsersManager.getCurrUser();
        this.company = this.user.company;

        this.register(AccountsService, Enums.PubSubTriggers.companyChanged, () => {
            this.company = this.user.company;
        });
    }

    let BrandAvatarComponentController = Class(Controllers.BaseController, {
        constructor: BrandAvatarComponentCtor,

        shouldShow() {
            return this.user.isVendor() && this.user.hasMultipleCompanies();
        },

        getCompanyInitials() {
            return this.company && this.company.company_name && this.company.company_name.split(' ').slice(0, 2).map((str) => { return str.charAt(0); }).join('');
        }
    });

    Components.BrandAvatar = {
        controller: BrandAvatarComponentController,
        controllerAs: 'brandAvatarVm',
        name: 'hbBrandAvatar',
        templateUrl: 'angular/app/modules/core/features/top_nav/brand_avatar/brand_avatar_component_template.html'
    };

}());